import { Container, ContainerSucces } from './styles'
import { useForm, ValidationError } from '@formspree/react'
import { toast, ToastContainer } from 'react-toastify'
import { useEffect, useState } from 'react'
import validator from 'validator'

export function Form() {
  const [state, handleSubmit] = useForm('mgvonzab')
  const [validEmail, setValidEmail] = useState(false)
  const [message, setMessage] = useState('')
  const [email, setEmail] = useState('')

  function verifyEmail(email: string) {
    setEmail(email)
    setValidEmail(validator.isEmail(email))
  }

  useEffect(() => {
    if (state.succeeded) {
      toast.success('Email successfully sent!', {
        position: toast.POSITION.BOTTOM_LEFT,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        hideProgressBar: false,
        toastId: 'succeeded',
      })

      // Reset form fields after successful submission
      setMessage('')
      setEmail('')
      setValidEmail(false)
    }

    if (state?.errors) {
      toast.error('Failed to send email. Please complete the reCAPTCHA.', {
        position: toast.POSITION.BOTTOM_LEFT,
        pauseOnFocusLoss: false,
        closeOnClick: true,
        hideProgressBar: false,
        toastId: 'error',
      })
    }
  }, [state.succeeded, state.errors])

  // if (state.succeeded) {
  //   return (
  //     <ContainerSucces>
  //       <h3>Thanks for getting in touch!</h3>
  //       <button
  //         onClick={() => {
  //           window.scrollTo({ top: 0, behavior: 'smooth' })
  //         }}
  //       >
  //         Back to the top
  //       </button>
  //       <ToastContainer />
  //     </ContainerSucces>
  //   )
  // }

  return (
    <Container>
      <h2>Get in touch</h2>
      <form onSubmit={handleSubmit}>
        <input
          placeholder="Email"
          id="email"
          type="email"
          name="email"
          value={email}
          onChange={(e) => verifyEmail(e.target.value)}
          required
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />

        <textarea
          required
          placeholder="Send a message to get started."
          id="message"
          name="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <ValidationError prefix="Message" field="message" errors={state.errors} />

        {/* Formspree reCAPTCHA */}
        <input type="hidden" name="g-recaptcha-response" />

        <button
          className="submitButton"
          type="submit"
          disabled={state.submitting || !validEmail || !message}
        >
          {state.submitting ? 'Sending...' : 'Submit'}
        </button>
      </form>
      <ToastContainer />
    </Container>
  )
}
